(function () {
  if (window.__popferrySwatchesBound) return;
  window.__popferrySwatchesBound = true;

  function getActiveGroup(gallery) {
    return gallery.querySelector('.popferry-variant-gallery__group[data-active="true"]');
  }

  function setSlideActive(slide, active) {
    if (!slide) return;
    slide.dataset.active = active ? 'true' : 'false';
  }

  function showPrimary(group) {
    var primary = group.querySelector('.popferry-variant-gallery__slide--primary');
    var hover = group.querySelector('.popferry-variant-gallery__slide--hover');
    setSlideActive(primary, true);
    setSlideActive(hover, false);
  }

  function showHover(group) {
    var primary = group.querySelector('.popferry-variant-gallery__slide--primary');
    var hover = group.querySelector('.popferry-variant-gallery__slide--hover');
    if (!hover) return; // no second image for this color
    setSlideActive(primary, false);
    setSlideActive(hover, true);
  }

  // ---- Swash chip click ----
  function handleClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var chip = target.closest('.popferry-swatches__chip');
    if (!chip) return;

    e.preventDefault();
    e.stopPropagation();

    var color = chip.dataset.color;

    var wrapper = chip.closest('popferry-swatches');
    if (wrapper) {
      wrapper.querySelectorAll('.popferry-swatches__chip').forEach(function (c) {
        c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
      });
    }

    var card = chip.closest('product-card') || chip.closest('[data-product-id]');
    if (!card) return;

    // Update card anchors so clicking the card lands on the PDP with the selected
    // colour pre-selected (and size = Medium when available — see swatches.liquid).
    var variantUrl = chip.dataset.variantUrl;
    if (variantUrl) {
      card.querySelectorAll('a[href]').forEach(function (anchor) {
        // Only retarget anchors that look like product links (skip external/utility links).
        var href = anchor.getAttribute('href') || '';
        if (href === '#' || href.indexOf('/products/') === 0 || href.indexOf('?variant=') !== -1) {
          anchor.setAttribute('href', variantUrl);
        }
      });
    }

    var gallery = card.querySelector('popferry-variant-gallery');
    if (!gallery) return;

    gallery.querySelectorAll('.popferry-variant-gallery__group[data-color]').forEach(function (g) {
      var isActive = g.dataset.color === color;
      g.dataset.active = isActive ? 'true' : 'false';
      showPrimary(g); // always reset to primary when (re)activating
    });
  }

  function attachHover(gallery) {
    if (gallery.dataset.hoverAttached === 'true') return;
    gallery.dataset.hoverAttached = 'true';
    gallery.addEventListener('mouseenter', function () {
      var ag = getActiveGroup(gallery);
      if (ag) showHover(ag);
    });
    gallery.addEventListener('mouseleave', function () {
      var ag = getActiveGroup(gallery);
      if (ag) showPrimary(ag);
    });
  }

  // Hover images render with loading="lazy" + fetchpriority="low" so they don't
  // compete with the primary image during initial paint. That makes them slow
  // to fetch on visible cards. Once a gallery is near the viewport, bump every
  // hover img inside it to eager + auto so it loads ASAP and hover is instant.
  /** @type {IntersectionObserver | null} */
  var hoverPreloadObserver = null;
  function getHoverPreloadObserver() {
    if (hoverPreloadObserver) return hoverPreloadObserver;
    if (typeof IntersectionObserver === 'undefined') return null;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target
            .querySelectorAll('.popferry-variant-gallery__slide--hover img')
            .forEach(function (img) {
              if (!(img instanceof HTMLImageElement)) return;
              img.loading = 'eager';
              if ('fetchPriority' in img) {
                /** @type {any} */ (img).fetchPriority = 'auto';
              }
            });
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '400px' }
    );
    hoverPreloadObserver = observer;
    return observer;
  }

  function preloadWhenVisible(gallery) {
    if (gallery.dataset.hoverPreloadObserved === 'true') return;
    gallery.dataset.hoverPreloadObserved = 'true';
    var observer = getHoverPreloadObserver();
    if (observer) observer.observe(gallery);
  }

  document.addEventListener('click', handleClick, true);

  // Hover-to-show-second-image only makes sense on devices that actually
  // hover. On touch devices it forces a "first tap activates hover, second
  // tap navigates" UX, which is broken — so skip the listeners entirely
  // when (hover: hover) isn't true.
  var supportsHover =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(hover: hover)').matches;

  function setupGallery(gallery) {
    attachHover(gallery);
    preloadWhenVisible(gallery);
  }

  // The first gallery on the page is always above the fold, so promote its
  // hover image to fetchpriority="high" + loading="eager" immediately. The
  // viewport observer otherwise bumps later galleries to "auto", which is
  // still slower than what we want for the very first card.
  function prioritizeFirstGallery() {
    var firstGallery = document.querySelector('popferry-variant-gallery');
    if (!firstGallery) return;
    firstGallery
      .querySelectorAll('.popferry-variant-gallery__slide--hover img')
      .forEach(function (img) {
        if (!(img instanceof HTMLImageElement)) return;
        if ('fetchPriority' in img) {
          /** @type {any} */ (img).fetchPriority = 'high';
        }
        img.loading = 'eager';
      });
  }

  function initAll() {
    if (!supportsHover) return;
    prioritizeFirstGallery();
    document.querySelectorAll('popferry-variant-gallery').forEach(setupGallery);
  }

  // Attach hover handlers + preload to galleries inserted after initial load
  // (e.g. infinite-scroll on the collection page).
  function observeNewGalleries() {
    if (!supportsHover || typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.matches('popferry-variant-gallery')) setupGallery(node);
          node.querySelectorAll('popferry-variant-gallery').forEach(setupGallery);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      observeNewGalleries();
    });
  } else {
    initAll();
    observeNewGalleries();
  }
})();
